import React, { useEffect, useState, useRef } from "react";
import Pagination from "../Homepage/Pagination";
import axiosInstance from "../../api";
import moment from "moment";

function AuditLog() {
  const [pages, setpages] = useState(0);
  const [page, setpage] = useState(1);
  const [total, setTotal] = useState(0);
  const [data, setData] = useState([]);

  useEffect(() => {
    axiosInstance
      .get(
        `${process.env.REACT_APP_API_URL}/api/AuditLog/GetAllAuditLogs/${page}`
      )
      .then((res) => {
        setData(res?.data?.data);
        setpages(res?.data?.pages);
        setTotal(res?.data?.count);
      })
      .catch(console.log);
  }, [page]);

  return (
    <section>
      <h1>Audit Log</h1>
      <p>{total} records</p>
      <section className="table">
        <section>
          <div>
            <aside style={{ gridTemplateColumns: "repeat(6, 1fr)" }}>
              <blockquote>Id</blockquote>
              <blockquote>Username</blockquote>
              <blockquote>Module</blockquote>
              <blockquote>Action Type</blockquote>
              <blockquote>Identifer</blockquote>
              <blockquote>DateTime</blockquote>
            </aside>
          </div>
          <div>
            {data.map((x) => (
              <aside style={{ gridTemplateColumns: "repeat(6, 1fr)" }}>
                <blockquote>{x.id}</blockquote>
                <blockquote>{x.username}</blockquote>
                <blockquote>{x.module}</blockquote>
                <blockquote>{x.actionType}</blockquote>
                <blockquote>{x.identifier}</blockquote>
                <blockquote>
                  {moment(new Date(x.actionDateTime)).format(
                    "DD/MM/YYYY HH:mm:ss"
                  )}
                </blockquote>
              </aside>
            ))}
          </div>
        </section>
      </section>
      <Pagination count={pages} pagenumber={page} setpagenumber={setpage} />
    </section>
  );
}

export default AuditLog;
